import SeoLandingTemplate, { SeoLandingPageData } from "@/components/marketing/SeoLandingTemplate";

const page: SeoLandingPageData = {
  path: "/questions-to-ask-interviewer",
  title: "Questions to Ask the Interviewer",
  seoTitle: "Best Questions to Ask an Interviewer | HiredCoach",
  seoDescription:
    "Practice asking better questions at the end of an interview so you sound thoughtful, natural, and prepared when the last five minutes matter.",
  heroEyebrow: "Closing questions",
  heroHeadline: "Most people waste the last 5 minutes of the interview",
  heroSubhead:
    "You either ask something thoughtful... or default to something generic and forgettable Most people don't realize which one they're doing",
  heroPrimaryCta: "Build confidence - get hired",
  heroPanelEyebrow: "What actually happens",
  heroPanelTitle: "What They're Actually Judging You On:",
  heroPanelBullets: [
    "Do you actually want this job?",
    "Are you thinking like someone who would succeed here?",
    "Would we want to work with you every day?",
  ],
  frameworkTitle: "Brain Freeze? Fall back to these",
  frameworkBullets: [
    "\"What does success look like in the first 90 days?\"",
    "\"What's the team trying to fix right now?\"",
    "\"How does this role work with other teams?\"",
    "\"What stood out about strong candidates before?\"",
  ],
  frameworkFooter: "This is where you either sound thoughtful... or like you're filling time.",
  exampleTitle: "These sound like you were actually paying attention",
  exampleBlocks: [
    "What would make someone really effective here early on?",
    "What are the biggest priorities for this role right now?",
    "Where do teams usually run into friction?",
  ],
  exampleFooter: "You do not memorize these. You adapt them to the conversation.",
  pressureTitle: "A lot of people walk out thinking:",
  pressureQuote: "\"I should've asked better questions\"",
  pressureFooter: "At that point, it's too late.",
  pressureFooterHighlight: "late",
  pressureBackgroundPhrases: [
    "should've asked something better",
    "why did i ask that",
    "that sounded generic",
    "i had better questions ready",
    "i wasted the last few minutes",
    "i sounded like i was filling time",
  ],
  mistakesTitle: "Where this usually goes wrong",
  mistakes: [
    "You ask something that is already on their website.",
    "You jump to perks too early.",
    "You panic and ask filler questions.",
    "You ask vague 'culture' questions that go nowhere.",
  ],
  mistakesFooter: "This is how you end up being forgettable.",
  ctaEyebrow: "Don't wing the last 5 minutes",
  ctaTitle: "Be prepared and practiced",
  ctaBullets: [
    "Practice asking questions out loud",
    "Hear what sounds natural",
    "Fix what doesn't",
  ],
  ctaFooter: "That's how you stop defaulting to generic.",
  ctaInfoCard: {
    title: "Get better at interviewing",
    path: "/public-learn",
    description: "Start with stronger interview frameworks, then practice how you actually close the conversation.",
  },
  ctaActionTitle: "This is why building confidence is key",
  ctaActionDescription: "Say it out loud. Hear what is off. Fix it while it is still obvious.",
  relatedTitle: "More interview questions worth actually practicing",
  relatedLinks: [
    {
      title: "How to Prepare for an Interview",
      path: "/how-to-prepare-for-an-interview",
      description: "A practical interview preparation guide covering research, answer practice, story prep, and mock interview rehearsal.",
    },
    {
      title: "Interview Tips",
      path: "/interview-tips",
      description: "Practical interview tips for answering clearly, sounding confident, and avoiding the mistakes that make strong candidates feel unprepared.",
    },
    {
      title: "Mock Interview Practice",
      path: "/mock-interview-practice",
      description: "Practice mock interviews with AI feedback, sharpen common interview answers, and turn Coach U frameworks into real interview reps.",
    },
  ],
  faqs: [
    { question: "How many questions should you ask an interviewer?", answer: "Usually 2 to 3.\n\nMore than that feels rehearsed. Less than that feels unprepared." },
    { question: "Should you ask about salary in the first interview?", answer: "Not in the first interview.\n\nUnless they bring it up or it is clearly the right moment." },
  ],
};

export default function QuestionsToAskInterviewerPage() {
  return <SeoLandingTemplate page={page} />;
}
